import Cookies from 'universal-cookie';
import { prepareProductPrice } from './utils';
import {
  createDyKeywordSearch,
  createDyAddCartEvent,
  createDyRemoveCartEvent,
  createDySortItemsEvent,
  createDyFilterEvent,
  createDyAddToWishlistEvent,
  createDyCartSyncEvent,
} from './event-creators';
import type {
  DyDataEvent,
  DyEventCartDetail,
  DyEventSortDetail,
  DyEventFilterDetail,
  DyEventWishlistDetail,
  DyCartSyncItem,
} from './types';
import { DY_SS_CART_SYNC_NECESSARY } from './constants';

const cookies = new Cookies();

export class DynamicYields {
  private dispatchEvent = (data: DyDataEvent | false) => {
    if (data && 'SL' in window && window.SL?.API) {
      window.SL?.API('event', data);
    }
  };

  public search = (value: string) => {
    const data = createDyKeywordSearch(value);
    this.dispatchEvent(data);
  };

  /**
   * @description Add To Cart
   * @param event: CustomEvent<DyEventCartDetail>
   */
  public handleAddToCart = (event: CustomEvent<DyEventCartDetail>) => {
    const { id, quantity, productPrice } = event.detail;

    const price = typeof productPrice === 'string' ? prepareProductPrice(productPrice) : productPrice;
    const data = createDyAddCartEvent(id, quantity, price);
    this.dispatchEvent(data);
  };

  /**
   * @description Remove from Cart
   * @param event:  CustomEvent<DyEventCartDetail>
   */
  public handleRemoveFromCart = (event: CustomEvent<DyEventCartDetail>) => {
    const { id, quantity, productPrice } = event.detail;
    const price = typeof productPrice === 'string' ? prepareProductPrice(productPrice) : productPrice;
    const data = createDyRemoveCartEvent(id, quantity, price);
    this.dispatchEvent(data);
  };

  /**
   * @description Sort Items
   * @param event: CustomEvent<DyEventSortDetail>
   */
  public handleSortItems = (event: CustomEvent<DyEventSortDetail>) => {
    const { sortBy, sortOrder } = event.detail;
    const data = createDySortItemsEvent(sortBy, sortOrder);
    this.dispatchEvent(data);
  };

  /**
   * @description Filter Items
   * @param event: CustomEvent<DyEventFilterDetail>
   */
  public handleFilterItems = (event: CustomEvent<DyEventFilterDetail>) => {
    const { filterNumericValue, filterType } = event.detail;
    const data = createDyFilterEvent(filterType, filterNumericValue);
    this.dispatchEvent(data);
  };

  /**
   * @description Add To Wish list
   * @param event: CustomEvent<DyEventWishlistDetail>
   */
  public handleAddToWishList = (event: CustomEvent<DyEventWishlistDetail>) => {
    const { id } = event.detail;
    const data = createDyAddToWishlistEvent(id);
    this.dispatchEvent(data);
  };

  public setDYSSVars = () => {
    const dySSCartSyncNecessary = cookies.get(DY_SS_CART_SYNC_NECESSARY);

    if (!dySSCartSyncNecessary) {
      cookies.set(DY_SS_CART_SYNC_NECESSARY, 'true');
    }
  };

  public isNeedCartSync = () => cookies.get(DY_SS_CART_SYNC_NECESSARY) === 'true';

  public syncCart = (dyCart: DyCartSyncItem[]) => {
    const data = createDyCartSyncEvent(dyCart);
    this.dispatchEvent(data);
    cookies.set(DY_SS_CART_SYNC_NECESSARY, 'false');
  };
}

export const dynamicYields = new DynamicYields();
